export const API_URL =
  process.env.VUE_APP_BACKEND_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:8081"
    : "https://toyhouse-api.duckdns.org");
